import React from "react";
import { useTranslation } from "react-i18next";

import Fields from "components/ui/Fields";
import { ProjectRoleSelector } from "components/common/ScopedRolesSelector";

function Form({ projects, data }) {
  const { t } = useTranslation();

  return (
    <>
      <Fields.Select
        label={t("Projects")}
        options={projects}
        name="projectsUids"
        data-qa="select_projects"
        disabled={data.isEdit}
        mode="multiple"
      />
      <ProjectRoleSelector name="roles" value={data.roles} />
    </>
  );
}

export default Form;
